
export const printTableData = (config) => {
  const {
    title = 'Print Report',
    columns = [],
    rows = [],
    excludeColumns = ['id'],
    formatValue = null,
    orientation = 'landscape'
  } = config;

  if (!columns.length || !rows.length) {
    console.warn('No data available to print');
    return false;
  }

  const filteredColumns = columns.filter(
    col => !excludeColumns.includes(col.dataKey)
  );

  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    return false;
  }

  const escapeHtml = (text) => {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  };

  const getSafeValue = (value, dataKey) => {
    if (formatValue && typeof formatValue === 'function') {
      const formatted = formatValue(value, dataKey);
      if (formatted !== undefined) {
        return escapeHtml(String(formatted));
      }
    }

    if (value === null || value === undefined) {
      return '-';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (typeof value === 'object') {
      return escapeHtml(JSON.stringify(value));
    }
    
    return escapeHtml(String(value));
  };

  const tableHeaders = filteredColumns
    .map(col => `<th>${escapeHtml(col.colLabel || col.dataKey)}</th>`)
    .join('');

  const tableRows = rows
    .map(row => {
      const cells = filteredColumns
        .map(col => {
          const value = row[col.dataKey];
          return `<td>${getSafeValue(value, col.dataKey)}</td>`;
        })
        .join('');
      return `<tr>${cells}</tr>`;
    })
    .join('');

  // Generate complete HTML document
  const printHTML = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${escapeHtml(title)} - Print</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
              "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
            padding: 0;
            background: #fff;
            color: #000;
            margin: 0;
          }
          
          .print-container {
            width: 100%;
            max-width: none;
            margin: 0;
            padding: 15px;
          }
          
          .print-header {
            margin-top: 0;
            margin-bottom: 20px;
            padding-bottom: 15px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          }

          .print-left {
            flex: 1;
            text-align: left;
          }

          .print-left h2 {
            font-size: 18px;
            font-weight: bold;
            color: #333;
            margin: 0 0 8px 0;
          }

          .print-date {
            font-size: 12px;
            color: #666;
            margin: 0;
          }

          .print-center {
            flex: 1;
            text-align: center;
          }

          h1 {
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            margin: 0;
            color: #333;
          }

          .print-spacer {
            flex: 1;
          }
          
          .table-wrapper {
            width: 100%;
            overflow-x: visible;
            overflow-y: visible;
          }
          
          table {
            width: 100%;
            max-width: none;
            border-collapse: collapse;
            background: #fff;
            table-layout: auto;
          }
          
          th, td {
            padding: 8px 10px;
            border: 1px solid #333;
            text-align: left;
            font-size: 10px;
            word-wrap: break-word;
            vertical-align: top;
            white-space: normal;
            overflow: visible;
            max-width: none !important;
            min-width: 80px;
          }
          
          th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: #000;
            position: sticky;
            top: 0;
          }
          
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          
          tr:hover {
            background-color: #f0f0f0;
          }
          
          @media print {
            body {
              padding: 0;
              margin: 0;
            }

            .print-container {
              padding: 5px;
            }

            * {
              overflow: visible !important;
            }
            
            table {
              page-break-inside: auto;
              width: 100% !important;
              table-layout: auto !important;
            }
            
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            
            thead {
              display: table-header-group;
            }
            
            tfoot {
              display: table-footer-group;
            }
            
            th {
              background-color: #f2f2f2 !important;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            tr:nth-child(even) {
              background-color: #f9f9f9 !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            th, td {
              overflow: visible !important;
              white-space: normal !important;
              word-wrap: break-word !important;
              max-width: none !important;
            }
            
            @page {
              margin: 0.5cm;
              size: ${orientation};
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="print-header">
            <div class="print-left">
              <h2>${escapeHtml(title)}</h2>
              <p class="print-date">${new Date().toLocaleString()}</p>
            </div>
            <div class="print-center">
              <h1>${escapeHtml(title)}</h1>
            </div>
            <div class="print-spacer"></div>
          </div>
          
          <div class="table-wrapper">
            <table>
              <thead>
                <tr>${tableHeaders}</tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </div>
        </div>

        <script>
          window.onload = function() {
            window.print();
          };

          window.onafterprint = function() {
            window.close();
          };
        </script>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(printHTML);
  printWindow.document.close();

  return true;
};

export const defaultValueFormatter = (value, dataKey) => {
  const lowerKey = dataKey.toLowerCase();

  if (lowerKey.includes('date') || lowerKey.includes('time')) {
    if (value && !isNaN(Date.parse(value))) {
      return new Date(value).toLocaleDateString();
    }
  }

  if (lowerKey.includes('price') || 
      lowerKey.includes('fee') ||
      lowerKey.includes('charge') ||
      lowerKey.includes('rate')) {
    if (!isNaN(value) && value !== null && value !== '') {
      return `$${Number(value).toFixed(2)}`;
    }
  }

  return undefined;
};
